<div class="login-container">
    <p-card>
        <img src="../../../../assets/images/logo.png" alt="" class="logo-img">
        <form [formGroup]="loginForm" (ngSubmit)="login()">
            <h1 class="welcome-title">
                Welcome back
            </h1>
            <p class="desc">
                Access the Lulu's Dashboard to manage operations and insights seamlessly.
            </p>
            <div class="custom-input-container ">
                <input formControlName="email" type="email" pInputText placeholder="Email or Username"
                    class="login-input" />
                <app-form-errors [control]="loginForm.controls['email']"></app-form-errors>

            </div>
            <div class="custom-input-container ">
                <input formControlName="password" type="password" pInputText placeholder="Password"
                    class="login-input" />
                <app-form-errors [control]="loginForm.controls['password']"></app-form-errors>

            </div>
            <button pButton type="submit" class="btn login-btn" [loading]="loadingSubmit"> Login </button>
        </form>
    </p-card>
    <img src="../../../../assets/images/login-side-img.png" alt="" class="side-img">

</div>